export default __webpack_public_path__ + "svg/calendar/2027/2/marzo.svg?7ffd5537";